module.exports = __webpack_public_path__ + "img/88009030001343.a98e5dbe.png";